const initialData = {
	runtime: true,
};

export default function runtimeReducer(state = initialData, action) {
	switch (action.type) {
		case "UPDATE_RUNTIME_STORE":
			return { ...state, ...action.data };

		default:
			return state;
	}
}
